<template>
  <div
    @click="goToProject"
    :class="{
      'bg-pitch-black': !project.hasNewActivity,
      'bg-dark-grey': project.hasNewActivity,
      'px-4 pr-5 pt-3 pb-4 border-b border-total-white-500 flex flex-col items-center w-full': true,
    }"
  >
    <div class="flex w-full justify-between items-center">
      <div class="flex overflow-hidden items-center space-x-2">
        <h3 class="flex-1 text-lg font-bold text-total-white truncate">
          {{ project.address_1 ? project.address_1 : "Untitled Project" }}
        </h3>
        <!-- Simulation tag: show if project.is_simulation is true -->
        <span
          v-if="project.is_simulation"
          :class="[
            'ml-2 flex-shrink-0 inline-block font-medium text-xs whitespace-nowrap text-prime-golden rounded-md px-2 py-1 border border-charcoal-grey',
            project.hasNewActivity ? 'bg-charcoal-grey' : 'bg-dark-grey',
          ]"
        >
          simulation
        </span>
      </div>
      <span
        v-if="project.hasNewActivity"
        class="text-xs flex-shrink-0 ml-2 flex gap-2 items-center text-prime-golden"
      >
        new activity
        <div class="w-3 h-3 bg-prime-golden rounded-full"></div>
      </span>
    </div>
    <div
      :class="{
        'bg-pitch-black': !project.hasNewActivity,
        'bg-dark-grey': project.hasNewActivity,
        'rounded-lg shadow-md mt-2 mb-1 pl-2 flex justify-between items-center w-full': true,
      }"
    >
      <div class="text-left overflow-hidden">
        <div class="flex items-center w-full text-sm text-total-white-800">
          <span class="font-semibold whitespace-nowrap mr-3">Next Milestone</span>
          <span class="flex-1 min-w-0 truncate">
            {{ project.next_milestone ? project.next_milestone : "No Milestone Set" }}
          </span>
        </div>

        <p class="text-sm mt-2 text-total-white-800">
          <span class="font-semibold mr-3"> Target Date</span>
          {{
            project.next_milestone_target_date
              ? formatDateToMMDDYYYY(project.next_milestone_target_date)
              : "No Target Date Set"
          }}
        </p>
      </div>
      <div class="text-prime-golden flex flex-col flex-shrink-0 items-end mt-3">
        <img
          src="@/assets/images/right-chevron.svg"
          alt="Right Chevron"
          width="16"
          height="16"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { useProjectStore } from "@/stores/project";

export default {
  name: "ProjectCard",
  props: {
    project: {
      type: Object,
      required: true,
    },
    arrayIndex: {
      type: Number,
      required: true,
    },
  },
  methods: {
    goToProject() {
      const projectStore = useProjectStore();
      projectStore.currentProject = this.project;
      this.$router.push({ name: "ProjectPage", params: { id: this.project.id } });
    },
    formatDateToMMDDYYYY(dateString) {
      if (!dateString) return "N/A";
      const date = new Date(dateString);
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const year = date.getFullYear();
      return `${month}/${day}/${year}`;
    },
  },
};
</script>

<style scoped>
.icon-chevron-right::before {
  content: ">";
}
</style>
